// A native RFC3339Nano timestamp, including a real calendar date. Parsing alone
// accepts normalized impossible dates; display formatting belongs to Intl later.
export function nativeTimestamp(value: unknown): value is string {
  if (typeof value !== 'string') return false;
  const match = /^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d):(\d\d)(?:\.\d{1,9})?(?:Z|([+-])(\d\d):(\d\d))$/.exec(value);
  if (!match) return false;
  const [,y,m,d,h,min,s,,oh,om] = match, year=Number(y), month=Number(m), day=Number(d);
  const days=[31,year%4===0&&(year%100!==0||year%400===0)?29:28,31,30,31,30,31,31,30,31,30,31];
  return year>0 && month>0 && month<=12 && day>0 && day<=days[month-1] && Number(h)<24 && Number(min)<60 && Number(s)<60 && (!oh || Number(oh)<24&&Number(om)<60) && Number.isFinite(Date.parse(value));
}
